import type { RefObject } from 'react';
import { useEventListener } from './useEventListener';

export function useOnClickOutside<T extends HTMLElement>(
  ref: RefObject<T | null> | Array<RefObject<T | null>>,
  handler: (event: MouseEvent) => void,
): void {
  useEventListener('mousedown', (event) => {
    const target = event.target as Node | null;
    if (!target?.isConnected) return;
    const mounted = (Array.isArray(ref) ? ref : [ref]).flatMap((r) => r.current ?? []);
    if (mounted.length > 0 && mounted.every((element) => !element.contains(target))) {
      handler(event);
    }
  });
}
